import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=3b139415&scoped=true&"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordCard.vue?vue&type=style&index=0&id=3b139415&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b139415",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VRow,VTextField})
